import { watch, onMounted } from 'vue';
import { useBag } from '~/modules/add-to-bag/composables/useBag';
import { useBagContext } from '~/modules/add-to-bag/composables/useBagContext';
import type { GIFT_CARD_FIELDS } from '../../types';

interface BagItem {
  sequenceNumber: number;
  itemTotalBeforeDiscount: number;
  giftCard?: {
    message?: string;
    fromMessage?: string;
    toMessage?: string;
    giftCardEmailId?: string;
  };
}

interface BagResult {
  sections: {
    bagItems: {
      items: BagItem[];
    };
  };
}

export const useGiftBasicPreselect = (values: Partial<Record<GIFT_CARD_FIELDS, string>>) => {
  const bag = useBag();
  const { sequenceNumber, isUpdateBagEnabled } = useBagContext();
  watch(bag.result, (newBag: BagResult) => {
    const targetItem = newBag?.sections?.bagItems?.items?.find((item) => item.sequenceNumber === sequenceNumber);

    if (!targetItem) {
      return;
    }

    const giftCardAmount = targetItem.itemTotalBeforeDiscount.toString();
    values.giftCardAmount = giftCardAmount;

    if (targetItem.giftCard) {
      values.giftCardMessage = targetItem.giftCard.message || '';
      values.giftCardFromName = targetItem.giftCard.fromMessage || '';
      values.giftCardToName = targetItem.giftCard.toMessage || '';
      values.giftCardEmailId = targetItem.giftCard.giftCardEmailId || '';
    }
  });

  onMounted(() => {
    if (!isUpdateBagEnabled) {
      return;
    }
    bag.fetch();
  });
};
